import { render, staticRenderFns } from "./_minigame.vue?vue&type=template&id=ca19817e&lang=pug&"
import script from "./_minigame.vue?vue&type=script&lang=js&"
export * from "./_minigame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports